import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Layout } from '../components'
import OrderList from '../components/OrderList/OrderList'
import Pagination from '../components/Pagination/Pagination'
import { Body } from '../components/Resource'
import { Auth, UserInfo } from '../contexts/allContext'
import { useRequest } from '../hooks/useRequest'

export default function OrdersPage() {
    const { stateUser } = useContext(UserInfo)
    const userInfo = stateUser.info
    const { stateAuth } = useContext(Auth)
    const token = stateAuth?.token
    const { handleFetch } = useRequest()
    const location = useLocation()
    const navigate = useNavigate()

    const [products, setProducts] = useState([])
    const [loading, setLoading] = useState(true)
    const [totalResults, setTotalResults] = useState(0)

    const [loading1, setLoading1] = useState(true)
    const [orderNumber, setOrderNumber] = useState('')
    const [orderProducts, setOrderProducts] = useState([])
    const [updateProductStatus, setUpdateProductStatus] = useState([])
    const [statusToggle, setStatusToggle] = useState(false)

    const queryParams = new URLSearchParams(location.search)
    const pageFromUrl = parseInt(queryParams.get('page')) || 1
    const [page, setPage] = useState(pageFromUrl - 1)
    const itemsPerPage = 10

    const fetchProducts = async (currentPage) => {
        // Don't proceed if no user ID is available
        if (!userInfo?.id) {
            setLoading(false)
            setProducts([])
            setTotalResults(0)
            return
        }

        setLoading(true)
        const skip = currentPage * itemsPerPage
        const params = {
            customer_user_id: userInfo.id, // User-specific filtering
            skip,
            limit: itemsPerPage,
        }

        try {
            const { data, isSuccess } = await handleFetch('v2/orders/', params, token)
            if (isSuccess && data && data.length > 0) {
                setProducts(data)
                setTotalResults(data[0].results || 0)
            } else {
                // Handle case where user has no orders
                setProducts([])
                setTotalResults(0)
            }
        } catch (err) {
            setProducts([])
            setTotalResults(0)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchProducts(page)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo?.id, page, statusToggle, token]) // Added token as dependency

    // Update URL when page changes
    useEffect(() => {
        const newPageNumber = page + 1
        const newQueryParams = new URLSearchParams(location.search)
        newQueryParams.set('page', newPageNumber)
        navigate(`?${newQueryParams.toString()}`, { replace: true }) // Fixed template literal
    }, [page, navigate, location.search])

    const fetchOrderProducts = async () => {
        if (!orderNumber || !token) {
            setLoading1(false)
            return
        }

        setLoading1(true)
        try {
            const { data, isSuccess } = await handleFetch(`v2/orders/single/${orderNumber}`, token) // Fixed template literal
            if (isSuccess) {
                setOrderProducts(data)
            } else {
                setOrderProducts([])
            }
        } catch (err) {
            setOrderProducts([])
        } finally {
            setLoading1(false)
        }
    }

    useEffect(() => {
        if (orderNumber) {
            fetchOrderProducts()
        } else {
            setOrderProducts([])
            setLoading1(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderNumber, token]) // Added token as dependency

    // Show loading or empty state when no user is available
    if (!userInfo?.id) {
        return (
            <Layout>
                <Body>
                    <div className="text-center p-4">
                        <p>Please log in to view your orders.</p>
                    </div>
                </Body>
            </Layout>
        )
    }

    return (
        <Layout>
            <Body>
                <OrderList
                    products={products}
                    loading={loading}
                    totalResults={totalResults}
                    setOrderNumber={setOrderNumber}
                    orderProducts={orderProducts}
                    loading1={loading1}
                    setUpdateProductStatus={setUpdateProductStatus}
                    updateProductStatus={updateProductStatus}
                    setStatusToggle={setStatusToggle}
                    statusToggle={statusToggle}
                />
                <Pagination
                    totalResults={totalResults}
                    itemsPerPage={itemsPerPage}
                    onPageChange={setPage}
                    currentPage={page}
                />
            </Body>
        </Layout>
    )
}
